// extracted by mini-css-extract-plugin
export var progressBar = "_na-0";
export var progressBarInner = "_na-1";